import * as React from 'react';

function SvgStarO(props) {
  return (
    <svg height="1em" viewBox="0 0 128 128" width="1em" {...props}>
      <path
        d="M82.23 101.301l-19.021-10.56s-17.659 8.893-19.156 9.645c-1.497.751-5.058-.425-4.447-3.552.608-3.129 4.085-20.961 4.085-20.961S30.684 62.639 28.752 60.795s-1.22-5.113 2.137-5.523l20.913-2.557s9.235-17.683 10.089-19.301c.854-1.621 4.368-1.738 5.246.145l9.193 19.713s19.994 3.345 21.657 3.65c2.582.479 2.779 3.662 1.227 5.106L83.381 76.773s2.989 19.79 3.294 22.219c.304 2.429-2.449 3.416-4.445 2.309z"
        fill="none"
        stroke="#F99E00"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={5}
      />
    </svg>
  );
}

export default SvgStarO;
